/**
 * React Native Timer Adapter
 * @module @one-payments/adapters-native
 */

import type { TimerAdapter } from '@one-payments/core';

/**
 * Native Timer Adapter using native JavaScript APIs
 */
export class NativeTimerAdapter implements TimerAdapter {
  public now(): number {
    return Date.now();
  }

  public async delay(ms: number): Promise<void> {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }
}
